import { useState } from "react"

export const TextBoxComponent = ({ name, inititalValue, onChange, isValid, required, questionKey, message = 'Field is required',placeHolder})=>{
    const [text, setText] = useState(inititalValue)
    const textOnChange = (e) =>{
        const value = e.target.value
        // if(questionKey === "mobileNumber"){
        //     var phoneno = /^\d{10}$/;
        //     if(phoneno.test(value)){
        //         setText(value);
        //     } else{
        //         return;
        //     }
        // }else{
        //     setText(value);
        // }
        setText(value);
        onChange(e.target.name, value,questionKey , required )
        
    }
    return(
        <div className="form-field">
            <input className={`txt-field ${required && !isValid ?'invalid-input':''}`} type="text" name={name} value={text} onChange={textOnChange} placeholder={placeHolder} />
            {required && !isValid && <p className="validation-error">{message}</p> }
        </div>
    )
}